/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "common": {
                "nested": {
                  "ProductSortField": {
                    "values": {
                      "CREATED_AT": 1,
                      "PRICE": 2,
                      "PRODUCT_KEY": 3,
                      "SLUG": 4,
                      "TAXON": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * Defines the supported Product fields to sort by.
 *
 * SOURCE ProductSortField @ squareup/solidshop/v2/common/sort_fields.proto at 9:1
 */
export const ProductSortField = $root.lookupEnum('squareup.solidshop.v2.common.ProductSortField').values;
